var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetroStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.133 50.667a2.533 2.533 0 100-5.067 2.533 2.533 0 000 5.067zM46.867 50.667a2.533 2.533 0 100-5.067 2.533 2.533 0 000 5.067z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.359 30.4h25.333v12.666H25.36V30.4zm27.334-15.707c-4.56-1.798-9.98-2.027-14.693-2.027-4.712 0-10.133.229-14.693 2.027-6.764 2.635-10.64 8.234-10.64 15.352v33.288h50.666V30.045c0-7.119-3.876-12.717-10.64-15.352zm.507 32.174c0 3.9-2.939 7.068-6.713 7.498l2.913 2.939v.962h-4.23l-3.8-3.8h-6.74l-3.8 3.8H26.6v-.962l2.913-2.939c-3.774-.43-6.713-3.597-6.713-7.498V30.4c0-6.663 7.6-7.6 15.2-7.6s15.2.937 15.2 7.6v16.467z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/Metro_station.07ba5e6b.svg";
export { SvgMetroStation as ReactComponent };